import React from "react"
import PropTypes from "prop-types"
import { ReactComponent as Airplane } from "../../images/airplane.svg"
import { ReactComponent as LongArrow } from "../../images/icons/long-arrow.svg"
import { FlexCol, FlexRow } from "../FlexGrid"
// import { TopDoublePanel } from "components/TopDoublePanel"
import FineResults from "./FineResults"
import EmailModule from "../EmailModule/EmailModule"
import { WarningModule } from "../WarningModule"
import { Link } from "gatsby"

import {
  ResultsContainer,
  OptionsContainer,
  RowTitle,
  OptionTitle,
  OptionText,
  TitleTextContainer,
  ResultsFlexGrid,
  ResultsFlexCol,
  TitleArrowContainer,
  ResultsTopDoublePanel,
} from "./style"

const ResultsLayout = ({ fineData, className }) => {
  console.log("fineData:", fineData)
  const topRightContent = <Airplane />

  const filteredFineData = fineData.filter(
    item => item.rowDetails.fineOptions && item.rowDetails.fineOptions.length
  )
  return (
    <ResultsContainer className={className}>
      <ResultsTopDoublePanel
        title="Here’s an overview of what you can do to fix your fine"
        body="<p>Help is always available. Just don’t ignore your fines.</p>"
        rightContent={topRightContent}
        // backBtn
      />

      {filteredFineData.map((rows, index) => {
        return (
          <OptionsContainer key={index}>
            <ResultsFlexGrid gap={[20, 20]} rowGap={[20]}>
              <FlexRow>
                <FlexCol xs={12}>
                  <RowTitle>{`${index + 1}. ${rows.title}`}</RowTitle>
                </FlexCol>
                {rows.rowDetails.fineOptions.map((card, index) => {
                  return (
                    <ResultsFlexCol
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      c1={[521, 6]}
                      key={index}
                    >
                      <TitleTextContainer important={card.highlight}>
                        <TitleArrowContainer>
                          <OptionTitle>
                            <Link
                              to={card.link}
                              dangerouslySetInnerHTML={{ __html: card.title }}
                            />
                          </OptionTitle>
                          <LongArrow />
                        </TitleArrowContainer>
                        <OptionText>{card.settings.excerpt}</OptionText>
                      </TitleTextContainer>
                    </ResultsFlexCol>
                  )
                })}
              </FlexRow>
            </ResultsFlexGrid>
          </OptionsContainer>
        )
      })}
      <EmailModule />
      <WarningModule />
    </ResultsContainer>
  )
}

export default ResultsLayout

ResultsLayout.defaultProps = {
  data: [
    {
      mainTitle: "Option 1—Contest the fine",
      cards: [
        {
          title: "Name another driver",
          excerpt:
            "For vehicle-related fines, the fine can be reassigned to the person driving at the time.",
          highlight: false,
        },
        {
          title: "Get your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Get enforcement of your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Challenge your fine in court",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: true,
        },
        {
          title: "Seek an annulment",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
      ],
    },
    {
      mainTitle: "Option 2—Get legal advice",
      cards: [
        {
          title: "Name another driver",
          excerpt:
            "For vehicle-related fines, the fine can be reassigned to the person driving at the time.",
          highlight: false,
        },
        {
          title: "Get your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Get enforcement of your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Challenge your fine in court",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: true,
        },
        {
          title: "Seek an annulment",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
      ],
    },
    {
      mainTitle: "Option 3—Get help paying",
      cards: [
        {
          title: "Name another driver",
          excerpt:
            "For vehicle-related fines, the fine can be reassigned to the person driving at the time.",
          highlight: false,
        },
        {
          title: "Get your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Get enforcement of your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Challenge your fine in court",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: true,
        },
        {
          title: "Seek an annulment",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
      ],
    },
    {
      mainTitle: "Option 4—Pay the fine",
      cards: [
        {
          title: "Name another driver",
          excerpt:
            "For vehicle-related fines, the fine can be reassigned to the person driving at the time.",
          highlight: false,
        },
        {
          title: "Get your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Get enforcement of your fine reviewed",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
        {
          title: "Challenge your fine in court",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: true,
        },
        {
          title: "Seek an annulment",
          excerpt:
            "Copy about this fine goes here. Copy about this fine goes here",
          highlight: false,
        },
      ],
    },
  ],
}

ResultsLayout.propTypes = {
  fineData: PropTypes.array,
  mainTitle: PropTypes.string,
  option01: PropTypes.object,
  option02: PropTypes.object,
  option03: PropTypes.object,
  option04: PropTypes.object,
  titles: PropTypes.array,
  excerpt: PropTypes.array,
  important: PropTypes.array,
}
